const forms = [
  {
    name: "Material Issue",
    className: "bg-white p-4 rounded-md p-8 w-[90%] mx-auto",
    text: "Issue",
    options: [
      {
        name: "Number",
        type: "select",
        form: {
          name: "number",
          allowClear: false,
          showSearch: true,
          filterOption: false,
          placeholder: "Material Request",
          api: "get-all-material-requests",
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Issue Number",
        type: "input",
        form: {
          type: "text",
          name: "issue_number",
          placeholder: "Issue number",
          class: "",
          value: "",
          required: false,
          disabled: true,
        },
      },
      {
        name: "Date",
        type: "date",
        form: {
          type: "text",
          name: "date",
          placeholder: "Issue date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Issue Date",
        type: "date",
        form: {
          type: "text",
          name: "issue_date",
          placeholder: "Material issue date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;